<template>
  <div class="home">
    <!-- mobile -->
    <!-- {{dataUrl}} -->
    <div v-if="$store.state.isMobile">
      <div class="banner" :style="`background:url(${imageStateUrl}${ticketDetail.museumImg}) center/100% no-repeat`">
      </div>
      <div class="content">
        <div class="title">{{ ticketDetail.ticketName?ticketDetail.ticketName:'' }}</div>
        <div :class="{
      'status': true,
      'status_g': ticketDetail.currentState == '正常开放',
      'status_r': ticketDetail.status == 0,
      'status_y': ticketDetail.status == 2
    }">{{ ticketDetail.currentState }}</div>
        <div class="museumTime">
          开馆时间：{{ ticketDetail.timeOpen }}-{{ ticketDetail.timeClose }}&nbsp;&nbsp;停止入馆时间：{{ ticketDetail.timeStop
          }}<br />预约上限：{{ ticketDetail.maxLimit }}人/天
        </div>
        <!-- :message="message" -->
        <notification 
        v-if="message.length"
        :message='message'
        ></notification>
        <div class="contentCard">
          <div class="cardTitle" v-if="showTitle">场馆简介</div>
          <div class="tips" v-html="ticketDetail.description"></div>
        </div>
        <div class="buttons">
          <div class="buttonNormal reservation" @click="reservation()">马上预约</div>
          <div class="myOrder" @click="toPersonalCenter" v-if="!isNaN(Number($route.query.museumCode))">个人中心</div>
          <div v-else class="myOrder" @click="myOrder">我的订单</div>
        </div>
      </div>
      <pop v-if="showPop">
        <slot>
          <div class="popContent">
            <div class="title">{{ notice.dictName }}</div>
            <div class="baseLine"></div>
            <div class="notice" v-html="notice.description"></div>
            <div class="buttonConfirm" @click="closePop">我知道了</div>
          </div>
        </slot>
      </pop>
    </div>
    <!-- pc -->
    <div v-else>
      <topBanner></topBanner>
      <div class="pcContent">
        <div class="topContent">
          <img :src="imageStateUrl + ticketDetail.museumImg">
          <div class="handelBlock">
            <div class="line">开馆时间 <span>{{ ticketDetail.timeOpen }}</span></div>
            <div class="line">停止入馆 <span>{{ ticketDetail.timeStop }}</span></div>
            <div class="line">预约上限 <span>{{ ticketDetail.maxLimit }}</span></div>
            <div class="line" v-if="ticketDetail.address">场馆地址<span>&nbsp;{{ ticketDetail.address }}</span></div>
            <div class="pcButtonWarp">
              <div class="button2" @click="reservation(1)" v-if="$store.state.ticketDetail.perOn">个人预约</div>
              <div class="button2" @click="reservation(2)" v-if="$store.state.ticketDetail.orgOn">团队预约</div>
            </div>
            <div class="button3 button3_f" @click="toPersonalCenter" v-if="!isNaN(Number($route.query.museumCode))">个人中心
            </div>
            <div class="button3 button3_f" @click="myOrder" v-else>我的订单</div>
          </div>
        </div>
        <div class="pcItemCard">
          <div class="lineBgc">
            <div class="left">
              <div class="title" v-if="showTitle">场馆简介</div>
              <p v-html="ticketDetail.description"></p>
            </div>
            <div class="right">
              <div class="title">{{ ticketDetail.inform ? notice.dictName : '通知公告' }}</div>
              <p v-if="ticketDetail.inform" v-html="notice.description"></p>
              <p v-else>暂无</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pop from '../../components/common/pop.vue'
import topBanner from '../../components/common/topBanner'
import notification from '../../components/common/notification'
export default {
  name: 'Home',
  data() {
    return {
      ticketDetail: {},
      statusText: ['停业', '开放', '约满'],
      showPop: false,
      notice: {},
      specialCodes: ['fcshzybwg', 'xeggmjng', 'ycsbwg'],
      showTitle: false,
      imageStateUrl: '',
      dataUrl: '',
      message:[]//消息通知
    };
  },

  components: { pop, topBanner,notification},

  methods: {
    // 个人中心
    toPersonalCenter() {
      if (!this.$cookie.get('token') && this.$route.query.loginUrl) return location.href = this.$route.query.loginUrl
      if (!this.$cookie.get('token')) return this.$router.push({ name: 'login', query: this.$route.query, params: { backOtherPage: 'personalCenter' } })
      let query = this.$route.query
      query.rType = this.$store.state.ticketDetail.perOn ? 1 : 2
      // delete query.code
      // this.$router.push({path: '/ticket/orders', query})
      this.$router.push({ name: 'personalCenter', query })
    },
    reservation(type) {
      let query = this.$route.query
      if (type) query.type = type
      if (!this.$cookie.get('token') && query.loginUrl) return location.href = query.loginUrl
      if (!this.$cookie.get('token')) return this.$router.push({ name: 'login', query, params: { backOtherPage: 'reservation' } })
      // delete query.code
      this.$router.push({ path: '/ticket/reservation', query })
    },

    myOrder() {
      if (!this.$cookie.get('token') && this.$route.query.loginUrl) return location.href = this.$route.query.loginUrl
      if (!this.$cookie.get('token')) return this.$router.push({ name: 'login', query: this.$route.query, params: { backOtherPage: 'orders' } })
      let query = this.$route.query
      query.rType = this.$store.state.ticketDetail.perOn ? 1 : 2
      // delete query.code
      this.$router.push({ path: '/ticket/orders', query })
    },

    closePop() {
      this.showPop = false
    },

    getticketDetail() {
      let url = this.$route.query.code ? `/api/ticket/front/ticket-info/code?museumCode=${this.$store.state.museumCode}&code=${this.$route.query.code}` : `/api/ticket/front/ticket-info?museumCode=${this.$store.state.museumCode}${this.$route.query.id ? `&ticketInfoId=${this.$route.query.id}` : ''}`
      this.$ajax.get(url).then((res) => {
        this.$store.state.ticketDetail = res.data[0]
        document.title = this.$store.state.ticketDetail.ticketName?this.$store.state.ticketDetail.ticketName:''
        this.ticketDetail = this.$store.state.ticketDetail
        console.log(this.ticketDetail)
        if(this.ticketDetail.notice){
          this.message.push(this.ticketDetail.notice)
        }
        // 判断是否显示标题
        let date = 1648713588000 //2022/3/31日之后的馆都不显示场馆简介四个字，需要的可以在富文本添加
        if (Date.parse(this.ticketDetail.crtTime) < date && this.specialCodes.indexOf(this.$route.query.museumCode) == -1) {
          this.showTitle = true
        }
        if (!this.ticketDetail.inform) return
        this.getInfo(this.ticketDetail.inform)
      })
    },

    getInfo(code) {
      this.$ajax(`/api/admin/front/dict/codeDictAll/${code}?museumCode=${this.$store.state.museumCode}`).then((res) => {
        this.notice = res.data
        if (this.$store.state.hasShowPop) return
        this.showPop = true
        this.$store.state.hasShowPop = true
      })
    },

    getMuseum() {
      this.$ajax(`/api/admin/front/group/name?museumCode=${this.$store.state.museumCode}`).then((res) => {
        this.$store.state.museumName = res.data
      })
    },

    // 从微服务带来的token
    getTokenByLoginApp() {
      let fid = this.$cookie.get('fid')
      if (!fid || (fid != this.$route.query.museumCode) || this.$cookie.get('token')) return
      this.$ajax.post(`/api/auth/jwt/login-app?fid=${fid}`).then((res) => {
        this.$cookie.set('token', res.data.token)
        var pat = /(\d{3})\d*(\d{4})/;
        let phone = res.data.mobilePhone.replace(pat, '$1****$2');
        this.$cookie.set('ticket_phone', phone)
      })
    },

    getCode() {
      this.$ajax(`/api/admin/front/dict/codeDictAll/ticket.title.${this.$route.query.museumCode}`).then((res) => {
        if (res.data && res.data.dictName) return document.title = res.data.dictName
        document.title = '票务预约'
      })
    },

    // 蒙速办的code
    getTokenByCode() {
      this.$ajax(`/api/auth/jwt/msb?museumCode=${this.$store.state.museumCode}&code=${this.$route.query.code}`).then((res) => {
        if (this.$cookie.get('token')) {
          this.$cookie.delete('token')
          this.$cookie.delete('ticket_phone')
        }
        this.$cookie.set('token', res.data.token)
        var pat = /(\d{3})\d*(\d{4})/;
        let phone = res.data.user.mobilePhone.replace(pat, '$1****$2');
        this.$cookie.set('ticket_phone', phone)
      })
    }
  },

  created() {

    this.dataUrl = location.href
    // this.getCode()
    if (this.$route.query.token) {
      if (this.$cookie.get('token')) {
        this.$cookie.delete('token')
        this.$cookie.delete('ticket_phone')
      }
      this.$cookie.set('token', this.$route.query.token)
      let phone = this.$route.query.phone
      var pat = /(\d{3})\d*(\d{4})/;
      phone = phone.replace(pat, '$1****$2');
      this.$cookie.set('ticket_phone', phone)
    }
    this.$store.state.museumCode = this.$route.query.museumCode
    if (this.$route.query.code && !this.$store.state.hasGetCode && this.$route.query.museumCode == 'xabwg') {
      this.$store.state.hasGetCode = true
      this.getTokenByCode()
    }
    this.imageStateUrl = !isNaN(Number(this.$store.state.museumCode)) ? '' : Glob.imgUrl
    this.$cookie.set('museumCode', this.$route.query.museumCode)
    if (this.$route.query.id) {
      this.$cookie.set('ticketId', this.$route.query.id)
    }
    this.getticketDetail()
    if (this.$cookie.get('_uid') && this.$cookie.get('fid') && this.$cookie.get('_d')) {
      this.getTokenByLoginApp()
    }
    if (this.$store.state.museumName) return
    this.getMuseum()
  }
}
</script>

<style scoped lang="scss">
.home {
  .contentCard {
    height: calc(100vh - 11.5rem);
    overflow-y: scroll;
  }

  .openingNotice {
    width: 100%;
    background-color: red;
    font-size: 0.36rem;
    position: relative;
  }

  .openingNotice .rowup {
    -webkit-animation: 10s rowup linear infinite normal;
    animation: 10s rowup linear infinite normal;
    position: relative;
  }

  .banner {
    height: 5rem;
    width: 10rem;
    // background: url('~@/assets/homeBgc.png') 0 0/100% no-repeat;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .content {
    border-radius: 0.7rem 0.7rem 0rem 0rem;
    margin-top: 4.1rem;
    min-height: calc(100vh - 4rem);
    background-color: #fff;
    z-index: 2;
    position: relative;
    margin-bottom: 1rem;

    .title {
      padding-top: 1rem;
      font-size: 0.7rem;
      line-height: 1rem;
      font-weight: 500;
      width: 7rem;
      margin: auto;
    }

    .status {
      position: absolute;
      top: -0.1rem;
      right: 0.4rem;
      width: 0.3rem;
      font-size: 0.3rem;
      color: #fff;
      line-height: 0.4rem;
      padding: 0.35rem 0.2rem 0.45rem 0.2rem;
    }

    .status::after {
      display: block;
      content: '';
      width: 0;
      height: 0;
      border-left: 0.35rem solid transparent;
      border-right: 0.35rem solid transparent;
      border-bottom: 0.35rem solid #fff;
      position: absolute;
      bottom: -0.02rem;
      right: 0;
    }

    .status_g {
      background-color: #7fa704;
    }

    .status_r {
      background-color: red;
    }

    .status_y {
      background-color: yellow;
    }

    .museumTime {
      margin-top: 0.3rem;
      font-size: 0.36rem;
      line-height: 0.65rem;
    }

    .cardTitle {
      font-size: 0.5rem;
      font-weight: 500;
      margin-bottom: 0.2rem;
    }

    .tips {
      font-size: 0.4rem;
      line-height: 0.65rem;
    }

    .buttons {
      margin-top: 0.7rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .reservation {
        margin: 0 0.5rem 0 3rem;
        position: relative;
      }

      .myOrder {
        font-size: 0.42rem;
        font-weight: 800;
        display: inline-block;
      }
    }
  }

  .popContent {

    // padding: 0.4rem 0.5rem;
    .title {
      font-size: 0.5rem;
      font-weight: 500;
      text-align: center;
    }

    .notice {
      font-size: 0.4rem;
      max-height: 60vh;
      overflow: scroll;
    }
  }

  .pcContent {
    .pcItemCard {
      padding: 35px 70px;
    }
  }

  .topContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 40px;

    img {
      width: 750px;
      height: 420px;
      border-radius: 30px;
    }
  }

  .handelBlock {
    width: 365px;
    margin-right: 20px;

    .line {
      font-size: 22px;
      font-weight: 500;
      text-align: left;
      line-height: 40px;
      margin-left: 35px;

      span {
        margin-left: 25px;
        font-size: 20px;
      }
    }
  }

  .button2 {
    margin-top: 30px;
    display: inline-block;

    &:nth-child(1) {
      margin-right: 39px;
    }
  }

  .button3 {
    margin: auto;
    margin-top: 0.2rem;
  }

  .pcItemCard {
    // padding: 0.2rem 0.5rem;
    overflow: hidden;

    .lineBgc {
      background: unset;
      padding: 0;
    }

    // .left, .right{
    //   width: 4rem;
    //   font-size: 0.13rem;
    //   text-align: left;
    // }
    // .title{
    //   text-align: center;
    //   font-weight: 500;
    //   font-size: 0.15rem;
    // }
    // .left{
    //   margin-right: 0.5rem;
    // }
  }
}
</style>
